import { HeroMosaicProps } from 'libs/growth-platform-brand-system-v2/src/templates/HeroMosaic';
import { createSchema, morphism } from 'morphism';
import { schemaMosaicItem } from '../components/schemaMosaicItem';

export const schemaHeroMosaic = createSchema<HeroMosaicProps, any>({
  backgroundColor: 'backgroundColor',
  title: 'title',
  subtitle: 'subtitle',
  items: {
    path: 'items',
    fn: (propertieValue: any[]) => {
      if (propertieValue) {
        return morphism(schemaMosaicItem, propertieValue);
      }
      return [];
    },
  },
});
